import styled from "styled-components";
import { apolloLineHeightSub, apolloSpaceInline1HalfX, apolloSpaceInlineHalfX, apolloSpaceInsetHalfX, } from "@nexthink/apollo-tokens";
import Icon from "../icons/Icon";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import Flex from "../box/Flex";
import Link from "../link/Link";
import apolloTheme from "../../theme/Theme";
export const ITEM_HORIZONTAL_PADDING = getValueFromPixelString(apolloSpaceInline1HalfX);
export const ICON_SIZE = 16;
export const LI_HEIGHT = `calc(${apolloLineHeightSub} + ${2 * getValueFromPixelString(apolloSpaceInsetHalfX)}px)`;
export const StyledIcon = styled(Icon).withConfig({ displayName: "StyledIcon_APC-7311-productShell", componentId: "sc-1rb8e0" })({
    "&&": {
        color: "inherit",
        height: "auto",
        width: ICON_SIZE,
    },
    marginRight: apolloSpaceInlineHalfX,
});
export const StyledExtra = styled(Flex).withConfig({ displayName: "StyledExtra_APC-7311-productShell", componentId: "sc-1adkcwf" })({
    padding: `0 ${apolloSpaceInline1HalfX} 0 0`,
    cursor: "pointer",
});
export const StyledExternalLinkIcon = styled(Icon).withConfig({ displayName: "StyledExternalLinkIcon_APC-7311-productShell", componentId: "sc-64tx6y" })({
    height: "auto",
    width: ICON_SIZE,
});
export const StyledExternalLink = styled(Link).withConfig({ displayName: "StyledExternalLink_APC-7311-productShell", componentId: "sc-1x0cemh" })(({ theme }) => ({
    display: "flex",
    opacity: 0,
    [StyledExternalLinkIcon]: {
        color: theme.colors.apolloColorTextPopoverSecondary,
    },
    "&:focus-visible": {
        opacity: 1,
    },
    [`&:hover ${StyledExternalLinkIcon}`]: {
        color: theme.colors.apolloColorTextPopoverPrimary,
    },
}));
export const StyledActionMenuItemContainer = styled(Flex).withConfig({ displayName: "StyledActionMenuItemContainer_APC-7311-productShell", componentId: "sc-1rdvfod" })(({ theme, $disabled, $focused }) => (Object.assign({ justifyContent: "space-between", alignItems: "center", "&:hover": Object.assign(Object.assign({}, (!$disabled && { background: theme.colors.apolloColorBackgroundPopoverHover })), { [StyledExternalLink]: {
            opacity: 1,
        } }) }, ($focused && {
    background: theme.colors.apolloColorBackgroundPopoverHover,
    [StyledExternalLink]: {
        opacity: 1,
    },
}))));
export const StyledActionMenuItem = styled(Link).withConfig({ displayName: "StyledActionMenuItem_APC-7311-productShell", componentId: "sc-1shz7i8" })(({ theme, $shouldUsePlaceholderIfNoIcon, $hasIcon, $disabled }) => ({
    // to avoid its style to be overridden when used with `as={Link}`
    "&&": Object.assign(Object.assign({ flexGrow: 1, display: "block", cursor: $disabled ? "default" : "pointer", whiteSpace: "nowrap", color: $disabled ? theme.colors.apolloColorTextPopoverDisabled : theme.colors.apolloColorTextPopoverPrimary }, apolloTheme.textStyles.sub), { lineHeight: LI_HEIGHT, height: LI_HEIGHT, paddingInline: ITEM_HORIZONTAL_PADDING, textDecoration: "none", "& > span": {
            display: "inline-flex",
            position: "relative",
            alignItems: "center",
            paddingLeft: $shouldUsePlaceholderIfNoIcon && !$hasIcon
                ? `${getValueFromPixelString(apolloSpaceInlineHalfX) + ICON_SIZE}px`
                : 0,
        }, 
        // display focus ring (simulation of outside-offset) when using keyboard
        "&:focus-visible": {
            // remove global style for focus ring
            boxShadow: "none !important",
            outline: "none !important",
            [`& + ${StyledExtra} ${StyledExternalLink}`]: {
                opacity: 1,
            },
        } }),
}));
//# sourceMappingURL=ActionMenuItem.style.js.map